import { useFormik } from 'formik'
import * as Yup from 'yup'

import { reportClientError } from '../../../../../../app/_components/chrome/scripts/DataDogRumScript'
import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { WaitlistService } from '../../contexts/WaitlistService'

interface IFormValues
  extends Readonly<{
    emailAddress: string
  }> {}

export function useWaitlistForm() {
  const { waitlist: waitlistCopy } = useTranslation()
  const { selectedVariant, sendWaitlistRequest, setErrorMessage, setSuccessMessage } =
    WaitlistService.useContainer()

  const validationSchema = Yup.object().shape({
    emailAddress: Yup.string()
      .email(waitlistCopy.modal.form.email.validEmailMessage)
      .required(waitlistCopy.modal.form.email.requiredMessage),
  })

  const formik = useFormik<IFormValues>({
    initialValues: {
      emailAddress: '',
    },
    onSubmit: async formValues => {
      const numericShopifyVariantIdMatch = selectedVariant?.shopifyId.match(/\d+$/)
      if (numericShopifyVariantIdMatch === null || numericShopifyVariantIdMatch === undefined) {
        reportClientError({
          error: new Error(
            `Shopify variant gid could not be parsed to an integer: ${selectedVariant?.shopifyId}`
          ),
          context: {
            scope: 'WaitlistModal onSubmit',
          },
        })
        return setErrorMessage(waitlistCopy.modal.errorMessage.unexpectedError)
      }
      const numericShopifyVariantId: number = parseInt(numericShopifyVariantIdMatch[0], 10)
      const waitlistRequestResult = await sendWaitlistRequest({
        email: formValues.emailAddress,
        variantId: numericShopifyVariantId,
      })

      switch (waitlistRequestResult) {
        case 'email-already-registered':
          return setErrorMessage(waitlistCopy.modal.errorMessage.emailAlreadyRegistered)
        case 'unexpected-error':
          return setErrorMessage(waitlistCopy.modal.errorMessage.unexpectedError)
        case 'success':
          return setSuccessMessage(waitlistCopy.modal.successMessage)
      }
    },
    validationSchema,
  })

  return formik
}
